import React from 'react';

const Contacts: React.FC = () => {
    return(
        <p>contacts</p>
    )
};

export default Contacts;